import { PartnerFieldsConfigurations } from '../../partner/models/partner-fields-configuration';

export class PartnerRegistrationConfiguration {

  fieldsConfiguration: PartnerFieldsConfigurations;

  static createFromAny(data: any): PartnerRegistrationConfiguration {
    if (!data) {
      return null;
    }

    const partnerRegistrationConfiguration = new PartnerRegistrationConfiguration();
    partnerRegistrationConfiguration.fieldsConfiguration = PartnerFieldsConfigurations.createFromAny(data.fieldsConfiguration);
    return partnerRegistrationConfiguration;
  }
}
